import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SharedService } from 'src/app/Services/sharedService';
import { ProjectService } from 'src/app/Services/project.service';
import moment from 'moment';

import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'app-request-details',
  standalone: true,
  imports: [
    CommonModule,
    MatTooltipModule,
    NgxSkeletonLoaderModule
  ],
  host: {
    class: 'block h-full w-full'
  },
  templateUrl: './request-details.component.html',
  styleUrl: './request-details.component.css'
})
export class RequestDetailsComponent implements OnInit, OnChanges {
  @Input() requestDetails: any;
  fullDetails: any;
  isLoading = false;

  constructor(
    private _sharedService: SharedService,
    private _projectService: ProjectService
  ) { }

  ngOnInit(): void {
    if (this.requestDetails && this.requestDetails.id) {
      this.fetchDetails();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['requestDetails'] && !changes['requestDetails'].firstChange) {
      this.fetchDetails();
    }
  }

  fetchDetails() {
    this.isLoading = true;
    this._projectService.getHelpRequestDetail(this.requestDetails.id).subscribe({
      next: (res: any) => {
        if (res && res.success) {
          this.fullDetails = res.data;
        }
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error fetching help request details:', err);
        this.isLoading = false;
      }
    });
  }

  closeDrawer() {
    this._sharedService.componentDrawerSubject.next({
      componentName: "help-and-support",
      componentData: null,
      componentAction: "close",
      componentWidth: 0
    });
  }

  getStatusClass(status: string): string {
    if (!status) return 'bg-gray-50 text-gray-700 border-gray-100';

    switch (status.toLowerCase()) {
      case 'submitted':
        return 'bg-[#fff5e6] text-[#ff9900] border-[#ffe0b3]';
      case 'in_review':
        return 'bg-[#fcf7e6] text-[#e2b300] border-[#f9eecc]';
      case 'closed':
        return 'bg-[#d9f2dd] text-[#21bc68] border-[#c0e8c6]';
      default:
        return 'bg-gray-50 text-gray-700 border-gray-100';
    }
  }

  convertToLocal(dateStr: string) {
    if (!dateStr) return null;
    return moment.utc(dateStr).local().toDate();
  }
}
